import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import SocialProofNotifications from "./components/feature/SocialProofNotifications";
import WhatsAppButton from "./components/feature/WhatsAppButton";
import TopBarTimer from "./components/feature/TopBarTimer";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Se houver hash, rolar até o elemento
    if (hash) {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          const offset = 100; // Offset para compensar navbar fixa
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Sem hash, rolar para o topo
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <a href="#main-content" className="skip-nav">Pular para conteúdo</a>
      <I18nextProvider i18n={i18n}>
        <TopBarTimer />
        <ScrollToTop />
        <AppRoutes />
        <SocialProofNotifications />
        <WhatsAppButton />
      </I18nextProvider>
    </BrowserRouter>
  );
}
